import React from "react";
import { FC } from "react";
import theme from "../../themes";
import makeStyles from "@material-ui/core/styles/makeStyles";
import { darken } from "@material-ui/core/styles/colorManipulator";
import { AdapterLink } from "../Adopter";
import { LinkProps } from "react-router-dom";

const useStyles = makeStyles(() => ({
  root: {
    fontWeight: 500,
    textDecoration: "none",
    color: "#aa933f",
    transition: theme.transitions.create(["color", "textDecoration"]),
    "&:hover": {
      textDecoration: "none",
      color: darken("#aa933f", 0.3),
    },
  },
}));

const FormLink: FC<LinkProps> = ({ to, children }) => {
  const classes = useStyles();

  return (
    <AdapterLink className={classes.root} to={to}>
      {children}
    </AdapterLink>
  );
};

export default React.memo(FormLink);
